import styled from "styled-components";

const borderRadius = 4;
const rowSpacing = 12;

export const Table = styled.table`
  width: 100%;
  font-size: 12px;
  font-family: Roboto;
  margin: 5px 0;
  overflow: auto;
  display: fixed;
`;

export const THead = styled.thead`
  height: 25px;
`;

export const HeaderRow = styled.tr`
  th {
    border-top-left-radius: ${borderRadius}px;
    border-bottom-left-radius: ${borderRadius}px;
    border-top-right-radius: ${borderRadius}px;
    border-bottom-right-radius: ${borderRadius}px;
  }
`;

export const Header = styled.th`
  text-align: ${({ textAlign }) => textAlign ?? "left"};
  background-color: white;
  padding: 0px 0px 0px 0px;
  width: 200px;
  position: relative;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  white-space: nowrap;
`;

export const TBody = styled.tbody``;

export const Row = styled.tr`
  border: 0;
  td {
    position: relative;
    height: 35px;
  }
  td .nowrap {
    white-space: nowrap;
  }
`;

export const Column = styled.td`
  height: inherit;
  width: ${({ width }) => (width !== undefined ? width : "auto")};
`;

export const ColumnContentWrapper = styled.div`
  height: calc(100% - ${rowSpacing / 2}px);
  margin-top: 5px;
  border-radius: ${borderRadius}px;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 5px;
`;

export const FlexWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: ${({ direction }) => direction ?? "row"};
  justify-content: ${({ justify }) => justify ?? "center"};
  align-items: ${({ align }) => align ?? "center"};
  color: ${({ color }) => color ?? "black"};
  font-weight: ${({ fontWeight }) => fontWeight ?? "normal"};

  :nth-child(2) {
    margin-top: 2px;
  }
`;
